exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-signup{background:transparent}.card-signup{margin-top:10%;padding:50px}.logo{width:90px;height:auto;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/confirmRegistration/confirmRegistration.scss
// module id = 628
// module chunks = 0